<template>
  <div>
    <toggle-single id="enable-agenda"
                   label-name="Enabled"
                   :toggle-model="hasNotifications"
                   @toggle-click="handleToggleClick"
                   />

    <toggles-form
        :data-array="toggles"
        @toggles-change="handleToggleChange"
    />

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import TogglesForm from "@/components/forms/togglesForm";
import ToggleSingle from "@/components/common/toggleSingle";
export default {
  name: "AddEditSession_Chat",
  components: {
    ToggleSingle,
    TogglesForm
  },
  props: {
    form: {
      type: Object,
      default: ()=>{
        return {}
      }
    }
  },
  beforeMount() {},
  mounted() {},
  computed: {
    ...mapGetters({}),
  },
  methods: {
    handleToggleChange(event) {
      debugger;
      //Maybe make top level
      let checkedId = event.target.id ? event.target.id : null;
      if (checkedId) {
        /*this.settingsUser[checkedId] = event.target.checked
            ? event.target.checked
            : false;*/
      }
      //this.handleSettingsUserChange(this.settingsUser);
      this.handleValueChange('togNotifications', event);
    },
    handleValueChange(key, value) { //mixin
      debugger;
      this.$emit('value-change', {key:key, value:value});
    },
    handleToggleClick(){
      //Add Emails
      this.hasNotifications = !this.hasNotifications;
    }
  },
  data() {
    return {
      production: true,
      clear: false,
      hasNotifications: this.form && this.form.hasNotifications ? this.form.hasNotifications : true,
      toggles: [
        {
          name: "invitation",
          description: "",
          property: "_invitation",
          type: "btns",
          text: "Invitation Email",
          isAvail: true,
          value: true
        },
        {
          name: "confirmation",
          description: "",
          property: "_confirmation",
          type: "btns",
          text: "Confirmation Email",
          isAvail: true,
          value: true
        },
        {
          name: "reminder",
          description: "",
          property: "_reminder",
          type: "btns",
          text: "Reminder Email",
          isAvail: true,
          value: false
        },
        {
          name: "ty",
          description: '',
          property: "_thankyou",
          type: "btns",
          text: "Thank You Email",
          isAvail: true,
          value: false
        },
        {
          name: "feedback",
          description: '',
          property: "_feedback",
          type: "btns",
          text: "Feedback",
          isAvail: true,
          value: false
        },
        {
          name: "sessionfeedback",
          description: "",
          property: "_sessionfeedback",
          type: "btns",
          text: "In-Sesssion Feedback",
          isAvail: true,
          value: false
        },
        {
          name: "linkedin",
          description: '',
          property: "_linkedin",
          type: "btns",
          text: "Social (LinkedIn)",
          isAvail: true,
          value: false
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.birthday_input {
  position: relative;
}
.session-calendar-wrapper {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1;
}
#session_calender .btn-outline-info:hover,
#session_calender .btn-outline-info:active,
#session_calender .btn-outline-info:focus {
  background-color: var(--theme-color);
  background: var(--theme-color);
}
</style>

